import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RequestService } from './request.service';
import { environment } from 'src/environments/environment';
import { Messaging, deleteToken, getToken, onMessage } from '@angular/fire/messaging';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, onSnapshot, query, setDoc, updateDoc, where, writeBatch } from '@angular/fire/firestore';
import { LoaderService } from './loader.service';
import { SendbirdService } from './sendbird.service';
import { PGIService } from './pgi.service';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FirebaseHandlersService {

  currentMessage = new BehaviorSubject(null);
  chatMessage = new BehaviorSubject(null);
  token: string = '';
  progressRef: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  // showHighPriorityDialog: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  pinnedMessageSubject: BehaviorSubject<any> = new BehaviorSubject<string>(undefined);
  channelDndSubject: BehaviorSubject<any> = new BehaviorSubject<string>(undefined);
  subscribedTopics: any = [];
  pinnedMessageSnapshot: any;
  dndSnapshot: any;
  userDndSnapshot: any;
  notificationsSnapshot: any;

  private isRegistered: boolean = false;
  private incomingMessageSourceId: string = '';
  private firestoreDb = getFirestore();

  constructor(private requestService: RequestService, private pgiService: PGIService, private messaging: Messaging, private loader: LoaderService, private sendBirdService: SendbirdService, private notificationService: NotificationService, private router: Router) {

    try {
      onMessage(this.messaging, (payload) => {
        if (payload.data?.channel_url && payload.data?.type != 'channel-rejection') {
          if (payload.data.sender_id != this.requestService.currentUser?._id && this.sendBirdService.channelId != payload.data.channel_url && !this.sendBirdService.dndChannels.find(i => i.channelId == payload.data.channel_url)?.dnd) {
            // let sendbirdData = JSON.parse(payload.data.sendbird);
            // this.sendBirdService.addUnreadChat(sendbirdData.channel.channel_url);
            // this.notificationService.showChatUnRead.next(true);
            this.chatMessage.next(payload);
          }
        }
        else if (payload.data?.type == 'channel-rejection') {
          this.currentMessage.next(payload);
        }
        else if (payload.data?.userId != this.requestService.currentUser?._id) {
          if (this.incomingMessageSourceId != payload.data.code) {
            this.incomingMessageSourceId = payload.data.code;
            this.currentMessage.next(payload);
            // console.log(payload)
          }
        }
      });

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('message', (event: any) => {
          // console.log('event', event)

          // if (event.data.action == 'channel-rejection') {
          //   this.currentMessage.next(event);
          // }
          // else
          if (event.data.action == 'redirect') {
            // window.location.href = event.data.redirect;
            // this.router.navigateByUrl(event.data.redirect);
            try {
              // Prefer router when possible, fallback to full-page navigation
              const url = new URL(event.data.redirect, window.location.origin);
              if (url.origin === window.location.origin) {
                this.router.navigateByUrl(url.pathname + url.search + url.hash).catch(() => {
                  window.location.assign(url.href);
                });
              } else {
                window.location.assign(url.href);
              }
            } catch {
              window.location.assign(event.data.redirect);
            }
          }
          else if (event.data.action == 'incoming-chat-message' && event.data.payload.data.sender_id != this.requestService.currentUser?._id && !this.sendBirdService.dndChannels.find(i => i.channelId == event.data.payload.data.channel_url)?.dnd) {
            // let sendbirdData = JSON.parse(event.data.payload.data);
            this.notificationService.showChatUnRead.next(true);
            // console.log(event.data.payload.data, event.data.payload)
            // this.chatMessage.next(event.data.payload);
            // this.sendBirdService.addUnreadChat(sendbirdData.channel.channel_url);
          }
        });
      }
    }
    catch (e) { console.log(e); }
  }

  registerDevice() {
    if ('serviceWorker' in navigator && window.location.pathname.indexOf('/mobile') == -1 && ('Notification' in window && Notification.permission === 'granted') && !this.token) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(() => {
          // Wait until the browser says the service worker is controlling the page
          return navigator.serviceWorker.ready;
        })
        .then((registration) => {
          // this.swRegistration = registration;
          // if (navigator.serviceWorker.controller) {
          //   navigator.serviceWorker.controller.postMessage({ userId: this.requestService.currentUser._id });
          // }
          getToken(this.messaging,
            { vapidKey: environment.firebaseVapidKey, serviceWorkerRegistration: registration }).then(
              (currentToken) => {
                this.token = currentToken;
                this.tokenSubject.next(this.token);
                // this.subscribeTopic('pgi-admin', userId);
                // console.log('currentToken', currentToken)
              }).catch(e => {
                console.log(e)
                // setTimeout(() => this.registerDevice(currentUserId), 5000);
              });
          console.log('Registration successful, scope is:', registration.scope);
        }).catch((err) => {
          console.log('Service worker registration failed, error:', err);
        });
    }
  }

  sendNotificationToDevice(receiverId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService.postRequest('notify', 'firebase/' + receiverId + '/push', payload, (data, error) => {
        if (data)
          resolve(data);
        else if (error)
          reject(error);
      });
    });
  }

  sendNotificationByTopic(topics: any, userId: string, payload: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.requestService.postRequest('notify', 'topic/send', {
        userId: userId,
        topic: topics,
        payload: payload
      }, (data, error) => {
        if (data) {
          resolve(data);
        } else if (error) {
          reject(error);
        }
      });
    });
  }

  sendAlertByTopic(topics: any, userId: string, payload: any, title, body, priority, pushedBy, recipients, role, state, carrier, agencyName): Promise<void> {
    let agencyID = this.requestService.currentUser?.mirror_1__1;
    return new Promise((resolve, reject) => {
      this.requestService.postRequest('notify', 'topic/v1', {
        userId: userId,
        topic: topics.map(topic => topic + `-${environment.environment}`),
        payload: payload,
        title: title,
        body: body,
        pushedBy: pushedBy,
        priority: priority,
        recipients: recipients,
        role: role,
        agency: agencyID,
        state: state,
        agency_name: agencyName,
        carrier: carrier,
      }, (data, error) => {
        if (data) {
          resolve(data);
        } else if (error) {
          reject(error);
        }
      });
    });
  }

  sendNotifications(userIds: [string], payload: any, title, body): Promise<void> {
    let agencyID = this.requestService.currentUser?.mirror_1__1;
    return new Promise((resolve, reject) => {
      this.requestService.postRequest('notify', 'users/send', {
        userIds: userIds,
        notification: {
          title: title,
          body: body,
        },
        data: payload,
      }, (data, error) => {
        if (data) {
          resolve(data);
        } else if (error) {
          reject(error);
        }
      });
    });
  }

  subscribeTopic(topics: any, userId: string): Promise<void> {
    if (topics?.length && userId) {
      return new Promise((resolve, reject) => {
        if (this.token && topics)
          this.requestService.postRequest('notify', 'subscribe/topic', {
            deviceToken: this.token,
            userId: userId,
            topic: topics.map(str => str.replace(/\s+/g, '-') + `-${environment.environment}`)
          }, (data, error) => {
            if (data) {
              localStorage.setItem('subscribed-topics', topics.join(","));
              this.subscribedTopics = topics;
              resolve(data);
            }
            else if (error)
              reject(error);
          });
      });
    }
  }

  unsubscribeTopic(topics: any, userId: string): Promise<void> {
    if (topics?.length) {
      return new Promise((resolve, reject) => {
        if (this.token && topics)
          this.requestService.postRequest('notify', 'unsubscribe/topic', {
            deviceToken: this.token,
            userId: userId,
            topic: topics.map(str => str.replace(/\s+/g, '-') + `-${environment.environment}`)
          }, (data, error) => {
            if (data) {
              this.subscribedTopics = this.subscribedTopics.filter(topic => {
                return !topics.includes(topic);
              });
              resolve(data);
            }
            else if (error)
              reject(error);
          });
      });
    }
  }

  unregisterDevice(userId: string, deviceId: string, callback: any, notValidToken: boolean = false): Promise<void> {
    this.isRegistered = false;
    return new Promise((resolve, reject) => {
      // getToken(this.messaging, { vapidKey: environment.firebaseVapidKey, serviceWorkerRegistration: this.swRegistration }).then((currentToken) => {
      // deleteToken(this.messaging).then(() => {
      if (this.token && !notValidToken)
        this.requestService.postRequest('notify', 'device/delete', {
          userId: userId,
          deviceId: deviceId,
          type: "Web"
        }, (data, error) => {
          // this.unsubscribeTopic('pgi-admin', userId);
          if (data)
            resolve(data);
          else if (error)
            reject(error);

          if (callback)
            callback();
        });
      else {
        resolve(undefined);

        if (callback)
          callback();
      }
      // }).catch((err) => {
      //   console.log(err);
      //   if (callback)
      //     callback();

      //   reject(err);
      // });
      // });
    });
  }

  async logout(notValidToken: boolean = false) {
    this.loader.display(true);
    this.sendBirdService.isConnectedSubject.next(false);
    this.token = '';
    await this.sendBirdService.disconnect();
    // this.adAuthService.logoutPopup().subscribe(() => {
    if (this.token) {
      // if (this.requestService.isUserRoleAdmin())
      // if (this.requestService.currentUser?._id)
      //   await this.sendBirdService.unRegisterToken(this.requestService.currentUser._id, this.token);
      this.isRegistered = false;
      // let unregisterDevicePromise = this.unregisterDevice(this.requestService._currentUser._id, this.token, undefined, notValidToken);

      // await Promise.all([unregisterDevicePromise]).then(() => {
      this.requestService.logOutApi(this.token);
      this.pgiService.resetPagesData();
      // }).catch(() => {
      //   this.requestService.logOutApi();
      // });
    }
    else {
      this.requestService.logOutApi(this.token);
      this.pgiService.resetPagesData();
    }
  }

  registerToken(token: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if (!this.isRegistered && this.requestService.currentUser?._id && token) {
        this.isRegistered = true;
        this.requestService.currentUser.deviceToken = token;
        localStorage.setItem('currentUser', JSON.stringify(this.requestService.currentUser));
        this.requestService.postRequest('notify', 'register', {
          userId: this.requestService.currentUser._id,
          type: "Web",
          deviceId: token
        }, (data, error) => {
          resolve();
        });
      }
      else {
        resolve();
      }
    });
  }

  registerTopics(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if (this.requestService.currentUser && this.requestService.currentUser.deviceToken && this.requestService.currentUser._id) {
        this.requestService.postRequest('notify', 'register/byrole', {
          role: this.requestService.getUserRole(),
          agency: { name: this.requestService.currentUser.agency?.name },
          deviceId: this.requestService.currentUser.deviceToken,
          userId: this.requestService.currentUser._id,
          codesAndStatuses: this.requestService.currentUser.codesAndStatuses,
          type: 'web',
        }, (data, error) => {
          if (data)
            resolve();
          else if (error)
            reject(error);
        });
      }
      else {
        reject();
      }
    });
  }

  async removeUserToken() {
    if (this.requestService.currentUser) {
      let currentUserId = this.requestService.currentUser._id;

      // let fs = getFirestore();
      const docRef = doc(
        this.firestoreDb,
        environment.firestore_config.notificationDb +
        '/fcm_token/users/' +
        currentUserId
      );
      let userData = await (await getDoc(docRef)).data();

      if (userData) {
        let TokensArray = userData.web_device_tokens;
        if (!TokensArray) TokensArray = [];
        let IsThere = TokensArray.find(
          (str: string) => str === this.requestService.currentUser.deviceToken
        );

        if (IsThere != undefined) {
          TokensArray = TokensArray?.filter(
            (tok: string) => tok != this.requestService.currentUser.deviceToken
          );
          const docRef = doc(
            this.firestoreDb,
            environment.firestore_config.notificationDb +
            '/fcm_token/users/' +
            currentUserId
          );
          updateDoc(docRef, {
            web_device_tokens: TokensArray,
          })
            .then(() => {
              this.logout();
            })
            .catch((err) => {
              throw new Error(err.message || err);
            });
          // }
        } else {
          this.logout();
        }
      }
    }
  }

  listenPinnedMessages(channelId: string) {
    // Demo mode: load from localStorage (always in demo mode for this build)
    try {
      const pinnedKey = `demo_pinned_${channelId}`;
      const pinnedDataStr = localStorage.getItem(pinnedKey);
      if (pinnedDataStr) {
        const pinnedData = JSON.parse(pinnedDataStr);
        this.pinnedMessageSubject.next({ messageId: pinnedData.messageId, channelId: channelId, fileType: pinnedData.fileType });
      } else {
        this.pinnedMessageSubject.next('');
      }
    } catch (e) {
      console.warn('[FirebaseHandlersService] Failed to load pinned message in demo mode:', e);
      this.pinnedMessageSubject.next('');
      // Fallback to Firestore if localStorage fails (shouldn't happen in demo)
      try {
        const docRef = doc(this.firestoreDb, environment.firestore_config.pinDb, channelId);
        this.pinnedMessageSnapshot = onSnapshot(docRef, (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            // console.log('Pinned message updated:', data.messageId, data);
            this.pinnedMessageSubject.next({ messageId: data.messageId, channelId: channelId, fileType: data.fileType });
          } else {
            this.pinnedMessageSubject.next('');
            // console.log('No pinned message found for this channel.');
          }
        }, (error) => {
          console.error('Error listening to pinned message:', error);
        });
      } catch (firestoreError) {
        console.error('[FirebaseHandlersService] Failed to set up Firestore listener:', firestoreError);
      }
    }
  }

  destroyListener() {
    if (this.pinnedMessageSnapshot)
      this.pinnedMessageSnapshot();

    if (this.dndSnapshot)
      this.dndSnapshot();
  }

  async addPinnedMessage(message: any, channelId: string) {
    // Demo mode: use localStorage (always in demo mode for this build)
    try {
      const pinnedKey = `demo_pinned_${channelId}`;
      const pinnedData = {
        messageId: message.messageId,
        createdAt: Date.now(),
        message: message.messageType?.toLowerCase() === 'file' ? message.customType : message.message,
        fileType: message.data?.fileType || message.type || null,
      };
      localStorage.setItem(pinnedKey, JSON.stringify(pinnedData));
      // Trigger the subject to update UI
      this.pinnedMessageSubject.next({ messageId: message.messageId, channelId: channelId, fileType: pinnedData.fileType });
    } catch (e) {
      console.warn('[FirebaseHandlersService] Failed to pin message in demo mode:', e);
      // Fallback to Firestore if localStorage fails (shouldn't happen in demo)
      try {
        const docRef = doc(this.firestoreDb, environment.firestore_config.pinDb, channelId);
        await setDoc(docRef, {
          messageId: message.messageId,
          createdAt: new Date(),
          message: message.messageType.toLowerCase() === 'file' ? message.customType : message.message,
          fileType: message.data?.fileType || null,
        });
      } catch (firestoreError) {
        console.error('[FirebaseHandlersService] Failed to pin message in Firestore:', firestoreError);
      }
    }
  }

  // async getPinnedMessage(channelId: string) {
  //   const docRef = doc(this.firestoreDb, environment.firestore_config.pinDb, channelId);
  //   const snap = await getDoc(docRef);

  //   if (snap.exists()) {
  //     this.pinnedMessageSubject.next({ messageId: snap.data().messageId, channelId: channelId });
  //     // console.log('Pinned message:', snap.data().messageId);
  //   }
  // }

  async deletePinnedMessage(channelId: string) {
    // Demo mode: use localStorage (always in demo mode for this build)
    try {
      const pinnedKey = `demo_pinned_${channelId}`;
      localStorage.removeItem(pinnedKey);
      // Trigger the subject to update UI
      this.pinnedMessageSubject.next('');
    } catch (e) {
      console.warn('[FirebaseHandlersService] Failed to unpin message in demo mode:', e);
      // Fallback to Firestore if localStorage fails (shouldn't happen in demo)
      try {
        await deleteDoc(doc(this.firestoreDb, environment.firestore_config.pinDb, channelId));
        this.pinnedMessageSubject.next('');
      } catch (error) {
        console.error('Error deleting pinned message:', error);
      }
    }
  }

  listenChannelDnd(userId: string) {
    // Demo mode: use localStorage (always in demo mode for this build)
    try {
      // In demo mode, we can load DND preferences from localStorage if needed
      // For now, just set a default value
      this.channelDndSubject.next({ dnd: false, channelId: '' });
    } catch (e) {
      console.warn('[FirebaseHandlersService] Failed to load channel DND in demo mode:', e);
      // Fallback to Firestore if localStorage fails (shouldn't happen in demo)
      const col = collection(this.firestoreDb, environment.firestore_config.userDb, userId, 'channel');

      this.dndSnapshot = onSnapshot(col, (querySnapshot) => {
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          // console.log(`Document ${docSnap.id} - isDnd:`, data.dnd);
          const {
            channelId,
            dnd
          } = data;

          this.channelDndSubject.next({ dnd: data.dnd, channelId: channelId });
        });
      });
    }
  }

  listenUserDnd(userId: string) {
    const col = doc(this.firestoreDb, environment.firestore_config.userDb, userId);

    this.userDndSnapshot = onSnapshot(col, async (querySnapshot) => {
      if (querySnapshot.exists()) {
        const data = querySnapshot.data();
        // console.log('isDnd:', data.dnd);
        this.notificationService.dnd.next(data.dnd);

        if (data.dnd) {
          // await this.unregisterDevice(userId, this.token, () => {
          // }).catch((e) => {
          // })
        }
        else {
          this.registerToken(this.token);
        }
      } else {
        // console.log('User document does not exist.');
      }
    });
  }

  listenNotifications(userId: string) {
    const col = collection(this.firestoreDb, environment.firestore_config.notificationDb, 'datas', 'alerts');
    let userQuery = query(col, where('userId', '==', userId), where('viewed', '==', false));

    this.notificationsSnapshot = onSnapshot(userQuery, async (querySnapshot) => {
      const notifications = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // console.log('notifications:', notifications);
      // if (querySnapshot.exists()) {
      // const data = querySnapshot.data();

      if (notifications.length) {
        this.notificationService.showNotificationUnRead.next(true);
      }
      else {
        this.notificationService.showNotificationUnRead.next(false);
      }

      this.notificationService.unreadHighPriority.next(notifications.filter((i: any) => i.priority));
      this.notificationService.notifications.next(notifications);
      // } else {
      // console.log('User document does not exist.');
      // }
    });
  }

  async markAsRead(userId: string) {
    const col = collection(this.firestoreDb, environment.firestore_config.notificationDb, 'datas', 'alerts');

    const userQuery = query(
      col,
      where('userId', '==', userId),
      where('viewed', '==', false)
    );

    const snapshot = await getDocs(userQuery);

    const batch = writeBatch(this.firestoreDb);

    snapshot.forEach(docSnap => {
      const docRef = doc(this.firestoreDb, col.path, docSnap.id);
      batch.update(docRef, { viewed: true });
    });

    await batch.commit();
  }
}